import * as action_types from "./constants";

const initialState = {
  // Add general Info
  generalInfoData: {},
  propertyDetailsData: {},
  propertyFeaturesData: {},
  // Paymane page
  paymentPageData: [],
  // TC Page Data
  tcPageData: {}
};

export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    // Add General Info
    case action_types.ADD_PROPERTY_GENERALINFO_DATA:
      return { ...state, generalInfoData: data };
    case action_types.ADD_PROPERTY_PROPERTY_DETAILS_DATA:
      return { ...state, propertyDetailsData: data };
    case action_types.ADD_PROPERTY_PROPERTY_FEATURES_DATA:
      return { ...state, propertyFeaturesData: data };
    
    // Payment page data
    case action_types.PAYMENT_PAGE_DATA:
      return { ...state, paymentPageData: data };

    // TC page data
    case action_types.TC_PAGE_DATA:
      return { ...state, tcPageData: data };
    default:
      return state;
  }
};
